import { render, staticRenderFns } from "./AddLeiBieModal.vue?vue&type=template&id=a866bb62&scoped=true"
import script from "./AddLeiBieModal.vue?vue&type=script&lang=js"
export * from "./AddLeiBieModal.vue?vue&type=script&lang=js"
import style0 from "./AddLeiBieModal.vue?vue&type=style&index=0&id=a866bb62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a866bb62",
  null
  
)

export default component.exports